/** md-transform.ts
 * 
 * Takes an input text string and converts to an HTML snippet inside <p> tags
 * 
 * tasks:
 *   inside <p> tags
 *   convert \n\n to </p><p>
 *   text in **text** to bold
 * 
 * 
 * if first char ! in #, `, > start in paragraph
 */



export function MdTransform( inputText: string ): string {
  let htmlSnippet: string = '<p>' + inputText.replace(/\n\n/g, "</p><p>").replace(/\n/g, "<br />") + '</p>';

  return htmlSnippet
}